import { render, staticRenderFns } from "./RewardCampaignList.vue?vue&type=template&id=0624edf8&scoped=true&"
import script from "./RewardCampaignList.vue?vue&type=script&lang=js&"
export * from "./RewardCampaignList.vue?vue&type=script&lang=js&"
import style0 from "./RewardCampaignList.vue?vue&type=style&index=0&id=0624edf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0624edf8",
  null
  
)

export default component.exports